export default __webpack_public_path__ + "static/tursab-dvs-8456-354abcbb22dca7cdebb1f025c6656611.webp";